<div class="container-fluid">
  @if (currentTimeColumn === 'Contribution Finish') {
    <p style="text-align: right; margin: 0px;">
      <b>{{'Contribute.lblTimeToClose' | translate}}</b>
    </p>
  }
  @if (currentTimeColumn === 'Contribution Start') {
    <p style="text-align: right; margin: 0px;">
      <b>{{'Contribute.lblTimeToOpen' | translate}}</b>
    </p>
  }
  <p style="text-align: right; margin: 0px">
    {{timeToOpenOrClose}}
  </p>
  <h4>
    {{contributeMarket.marketCode}} {{'Contribute.header' | translate}}
  </h4>
  <mat-tab-group dynamicHeight mat-align-tabs="start" mat-stretch-tabs="false" selectedIndex="{{showTransaction() && showSubmission() == false ? '1': '0'}}" animationDuration="1000ms" class="{{showTransaction() && showSubmission()? '' : ' hideTabs'}}">
    <mat-tab label="{{'Contribute.lblSubmissions' | translate}}" [ngStyle]="{'display': showSubmission() === true ? 'inline' : 'none' }">
      <app-contribution-summary (getTransactions)="GetTransactions()" (getContributions)="GetContributions()" (checkOverrideWindow)="CheckWindowOverride('submission'); CheckWindowOverride('transaction')"></app-contribution-summary>
      @if (showSubmission()) {
        <div [@slider]="showSubmission()? 'show' : null" class="slider">
          <p style="margin: 10px">{{shortdescription}}</p>
          <p style="margin: 10px">{{'Contribute.spreadsheetUpload' | translate}}</p>
          <div style="max-width: 1024px">
            <div class="row m-0">
              <mat-form-field class="col-6">
                <mat-label>{{'Contribute.lblSpreadsheet' | translate}}</mat-label>
                <input matInput type="text" readonly [(ngModel)]="spreadsheetFilename" [ngModelOptions]="{standalone: true}" />
                <input [hidden]="true" #spreadsheetInput type="file" (click)="spreadsheetInput.value=null" (change)="spreadsheetInputChange($event)" accept=".xls,.xlsx" />
                <button matSuffix mat-flat-button (click)="spreadsheetInput.click()">{{'btnSelect' | translate}}</button>
              </mat-form-field>
              <div class="col-6">
                <button mat-raised-button style="float: right;" color="primary" type="button" (click)="OnClickPopulate()">
                  {{ 'Contribute.btnPopulate' | translate }}
                </button>
              </div>
            </div>
          </div>
          <div id="contributeTable" class="mt-3 mat-elevation-z6">
            <form>
              <table mat-table [dataSource]="dataSourceNew">
                <ng-container matColumnDef="name">
                  <th mat-header-cell *matHeaderCellDef style="width: 25%"> {{'Contribute.thTenor' | translate}}</th>
                  <td mat-cell *matCellDef="let element" [style.color]="element.notes.trim() !== '' ? (element.instrumentAccepted ? 'green' : 'red') : ''">{{element.instrumentDescription}}</td>
                </ng-container>
                <ng-container matColumnDef="space">
                  <th mat-header-cell *matHeaderCellDef style="width: auto"> </th>
                  <td mat-cell *matCellDef="let element"></td>
                </ng-container>
                <ng-container matColumnDef="assessedRate">
                  <th mat-header-cell *matHeaderCellDef style="width: 10%"> {{'Contribute.thAssessedRate' | translate}}</th>
                  <td mat-cell *matCellDef="let element">
                    <mat-label class="{{(element.newRate !== element.rate) && (element.newRate) ? 'hasChangedClass' : (element.notes.trim() !== '' ? (element.instrumentAccepted ? 'hasAccepted' : 'hasRejected') : '')}}" matTooltip="{{element.notes}}"> {{element.assessedRate}} </mat-label>
                  </td>
                </ng-container>
                <ng-container matColumnDef="assessedVolume">
                  <th mat-header-cell *matHeaderCellDef style="width: 10%"> {{'Contribute.thAssessedVolume' | translate}}</th>
                  <td mat-cell *matCellDef="let element">
                    <mat-label class="{{(element.newVolume !== element.volume) && (element.newVolume) ? 'hasChangedClass' : (element.notes.trim() !== '' ? (element.instrumentAccepted ? 'hasAccepted' : 'hasRejected') : '')}}" matTooltip="{{element.notes}}"> {{element.assessedVolume}} </mat-label>
                  </td>
                </ng-container>
                <ng-container matColumnDef="level">
                  <th mat-header-cell *matHeaderCellDef style="width: 10%"> {{'Contribute.thLevel' | translate}}</th>
                  <td mat-cell *matCellDef="let element" [style.color]="element.notes.trim() !== '' ? (element.instrumentAccepted ? 'green' : 'red') : ''">{{element.level}}</td>
                </ng-container>
                <ng-container matColumnDef="newRate">
                  <th mat-header-cell *matHeaderCellDef style="width: 10%"> {{'Contribute.thCOF' | translate}}</th>
                  <td mat-cell *matCellDef="let element">
                    <mat-label class="{{(element.newRate !== element.rate) && (element.newRate) ? 'hasChangedClass' : (element.notes.trim() !== '' ? (element.instrumentAccepted ? 'hasAccepted' : 'hasRejected') : '')}}"> {{element.newRate}} </mat-label>
                  </td>
                </ng-container>
                <ng-container matColumnDef="defaultSpread">
                  <th mat-header-cell *matHeaderCellDef style="width: 10%"> {{'Contribute.thDefaultSpread' | translate}}</th>
                  <td mat-cell *matCellDef="let element">
                    <mat-label class="{{(element.defaultSpread !== element.spread) ? 'hasChangedClass' : ''}}">{{element.defaultSpread}}</mat-label>
                  </td>
                </ng-container>
                <ng-container matColumnDef="newSpread">
                  <th mat-header-cell *matHeaderCellDef style="width: 10%"> {{'Contribute.thNewSpread' | translate}}</th>
                  <td mat-cell *matCellDef="let element" class="{{(element.newSpread !== element.spread) ? 'hasChangedClass' : (element.notes.trim() !== '' ? (element.instrumentAccepted ? 'hasAccepted' : 'hasRejected') : '')}}">{{element.newSpread}}</td>>
                </ng-container>
                <ng-container matColumnDef="fsaCOF">
                  <th mat-header-cell *matHeaderCellDef style="width: 10%"> {{'Contribute.thFSACOF' | translate}}</th>
                  <td mat-cell *matCellDef="let element" [style.color]="element.notes.trim() !== '' ? (element.instrumentAccepted ? 'green' : 'red') : ''">{{element.fsaCOF}}</td> <!-- Convince html to treat these values ​​as numbers -->
                </ng-container>
                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef style="width: 5%"></th>
                  <td mat-cell *matCellDef="let element" style="text-align: center">
                    <button mat-icon-button color="primary" (click)="OnEditRecord(element)">
                      <mat-icon>edit</mat-icon>
                    </button>
                  </td>
                </ng-container>
                <ng-container matColumnDef="loading">
                  <th class="loading" mat-footer-cell *matFooterCellDef colspan="12">{{'tblLoading' | translate}}... </th>
                </ng-container>
                <ng-container matColumnDef="noData">
                  <th class="loading" mat-footer-cell *matFooterCellDef colspan="12">
                    {{'Contribute.tblNoData' | translate}}...
                  </th>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayColumns;" matTooltip="{{row.notes}}"></tr>
                <tr mat-footer-row *matFooterRowDef="['loading']" [ngClass]="{'hide':dataSourceNew!=null}"></tr>
                <tr mat-footer-row *matFooterRowDef="['noData']" [ngClass]="{'hide':dataSourceNew!=null && instrumentLength != 0}"></tr>
              </table>
            </form>
          </div>
          @if (service.currentUser.isReadOnly === false) {
            <div style="margin: 10px;">
              <button style="float: right;" [disabled]="!canEnablebtnSubmit" mat-raised-button color="primary" type="button" (click)="OnSubmitClick()">
                {{ 'btnSubmit' | translate }}
              </button>
            </div>
          }
        </div>
      }
    </mat-tab>
    <mat-tab label="{{'Contribute.lblTransactions' | translate}}" [ngStyle]="{'display': showTransaction() === true ? 'inline' : 'none' }">
      <div [@slider]="showTransaction()? 'show' : null">
        <h5>
          {{'Contribute.headerSubmitTrans' | translate}}
        </h5>
        <div class="row m-0">
          <mat-form-field class="col-6" style="padding-left: 0">
            <mat-label>
              {{'Contribute.lblTransactionFile' | translate}}
            </mat-label>
            <input matInput type="text" readonly [(ngModel)]="xmlFilename" [ngModelOptions]="{standalone: true}" />
            <input [hidden]="true" #transactionInput type="file" (click)="transactionInput.value=null" (change)="transactionInputChange($event)" accept=".xml" />
            <button matSuffix mat-flat-button (click)="transactionInput.click()">
              {{'btnSelect' | translate}}
            </button>
          </mat-form-field>
          <div class="col-6">
            <button mat-raised-button style="float: right;" color="primary" type="button" (click)="OnClickTransactionSubmit()">
              {{ 'btnSubmit' | translate }}
            </button>
          </div>
        </div>
        <h5>
          {{'Contribute.headerSubmittedTrans' | translate}}
        </h5>
        <p>
          {{ 'Contribute.lblTransDescription' | translate }}
        </p>
        @if (service.currentUser.isReadOnly === false) {
          <button mat-raised-button (click)="OnCreateTrade()">
            <mat-icon>add</mat-icon> {{'Contribute.lblNewTransaction' | translate}}
          </button>
        }
        <div class="scrollableTable mat-elevation-z8" style="overflow: auto">
          <div class="search-div">
            <mat-form-field class="search-form-field">
              <input matInput [(ngModel)]="searchKey" placeholder="{{'Contribute.plchldrSearchTrans' | translate}}" autocomplete="off" (keyup)="ApplyFilter()">
              @if (searchKey) {
                <button mat-button matSuffix mat-icon-button aria-label="Clear" (click)="OnSearchClear()">
                  <mat-icon>close</mat-icon>
                </button>
              }
            </mat-form-field>
          </div>
          <table #sortTrans="matSort" mat-table [dataSource]="dataSourceTrans" matSort matSortActive="contributed" matSortDirection="desc">
            <ng-container matColumnDef="state">
              <th mat-header-cell mat-sort-header *matHeaderCellDef style="min-width: 5%">
              </th>
              <td mat-cell *matCellDef="let element">
                <mat-icon class="material-icons-outlined {{element.stateColor}}">
                  {{element.state}}
                </mat-icon>
              </td>
            </ng-container>
            <ng-container matColumnDef="contributed">
              <th mat-header-cell mat-sort-header *matHeaderCellDef style="min-width: 5%">
                {{'Contribute.thContributed' | translate}}
              </th>
              <td mat-cell *matCellDef="let element" style="white-space: nowrap">
                {{element.contributed | date:"d MMM yyyy h:mm:ss a"}}
              </td>
            </ng-container>
            <ng-container matColumnDef="currency">
              <th mat-header-cell mat-sort-header *matHeaderCellDef style="min-width: 5%">
                {{'Contribute.thCurrency' | translate}}
              </th>
              <td mat-cell *matCellDef="let element" matTooltip="{{checkTradeColumn(element, 'currency', true)}}" class="{{checkTradeColumn(element, 'currency') == 'true' ? 'hasChangedClass' : ''}}">
                {{element.currency.value}}
              </td>
            </ng-container>
            <ng-container matColumnDef="status">
              <th mat-header-cell mat-sort-header *matHeaderCellDef style="min-width: 5%">
                {{'Contribute.thStatus' | translate}}
              </th>
              <td mat-cell *matCellDef="let element" matTooltip="{{checkTradeColumn(element, 'status', true)}}" class="{{checkTradeColumn(element, 'status') == 'true' ? 'hasChangedClass' : ''}}">
                {{element.status}}
              </td>
            </ng-container>
            <ng-container matColumnDef="cpSector">
              <th mat-header-cell mat-sort-header *matHeaderCellDef style="min-width: 5%">
                {{'Contribute.thCpSector' | translate}}
              </th>
              <td mat-cell *matCellDef="let element" matTooltip="{{checkTradeColumn(element, 'counterParty', true)}}" class="{{checkTradeColumn(element, 'counterParty') == 'true' ? 'hasChangedClass' : ''}}">
                {{element.counterParty}}
              </td>
            </ng-container>
            <ng-container matColumnDef="type">
              <th mat-header-cell mat-sort-header *matHeaderCellDef style="min-width: 5%">
                {{'Contribute.thType' | translate}}
              </th>
              <td mat-cell *matCellDef="let element" matTooltip="{{checkTradeColumn(element, 'type', true)}}" class="{{checkTradeColumn(element, 'type') == 'true' ? 'hasChangedClass' : ''}}">
                {{element.type}}
              </td>
            </ng-container>
            <ng-container matColumnDef="instrumentType">
              <th mat-header-cell mat-sort-header *matHeaderCellDef style="min-width: 5%">
                {{'Contribute.thInstrumentType' | translate}}
              </th>
              <td mat-cell *matCellDef="let element" matTooltip="{{checkTradeColumn(element, 'instrumentType', true)}}" class="{{checkTradeColumn(element, 'instrumentType') == 'true' ? 'hasChangedClass' : ''}}">
                {{element.instrumentType}}
              </td>
            </ng-container>
            <ng-container matColumnDef="identifier">
              <th mat-header-cell mat-sort-header *matHeaderCellDef style="min-width: 5%">
                {{'Contribute.thIdentifier' | translate}}
              </th>
              <td mat-cell *matCellDef="let element" matTooltip="{{checkTradeColumn(element, 'identifier', true)}}" class="{{checkTradeColumn(element, 'identifier') == 'true' ? 'hasChangedClass' : ''}}" style="white-space: nowrap">
                {{element.identifier}}
              </td>
            </ng-container>
            <ng-container matColumnDef="tradeDate">
              <th mat-header-cell mat-sort-header *matHeaderCellDef style="min-width: 120px">
                {{'Contribute.thTradeDate' | translate}}
              </th>
              <td mat-cell *matCellDef="let element" matTooltip="{{checkTradeColumn(element, 'tradeDate', true)}}" class="{{checkTradeColumn(element, 'tradeDate') == 'true' ? 'hasChangedClass' : ''}}">
                {{element.tradeDate | date:"d MMM yyyy"}}
              </td>
            </ng-container>
            <ng-container matColumnDef="settlementDate">
              <th mat-header-cell mat-sort-header *matHeaderCellDef style="min-width: 5%">
                {{'Contribute.thSettlementDate' | translate}}
              </th>
              <td mat-cell *matCellDef="let element" matTooltip="{{checkTradeColumn(element, 'settlementDate', true)}}" class="{{checkTradeColumn(element, 'settlementDate') == 'true' ? 'hasChangedClass' : ''}}">
                {{element.settlementDate | date:"d MMM yyyy"}}
              </td>
            </ng-container>
            <ng-container matColumnDef="maturityDate">
              <th mat-header-cell mat-sort-header *matHeaderCellDef style="min-width: 5%">
                {{'Contribute.thMaturityDate' | translate}}
              </th>
              <td mat-cell *matCellDef="let element" matTooltip="{{checkTradeColumn(element, 'maturityDate', true)}}" class="{{checkTradeColumn(element, 'maturityDate') == 'true' ? 'hasChangedClass' : ''}}">
                {{element.maturityDate | date:"d MMM yyyy"}}
              </td>
            </ng-container>
            <ng-container matColumnDef="nominalAmount">
              <th mat-header-cell mat-sort-header *matHeaderCellDef style="min-width: 5%">
                {{'Contribute.thNomAmount' | translate}}
              </th>
              <td mat-cell *matCellDef="let element" matTooltip="{{checkTradeColumn(element, 'nominalAmount', true)}}" class="{{checkTradeColumn(element, 'nominalAmount') == 'true' ? 'hasChangedClass' : ''}}">
                {{FormatNumber(element.nominalAmount)}}
              </td>
            </ng-container>
            <ng-container matColumnDef="rate">
              <th mat-header-cell mat-sort-header *matHeaderCellDef style="min-width: 5%">
                {{'Contribute.thRate' | translate}}
              </th>
              <td mat-cell *matCellDef="let element" matTooltip="{{checkTradeColumn(element, 'rate', true)}}" class="{{checkTradeColumn(element, 'rate') == 'true' ? 'hasChangedClass' : ''}}">
                {{element.rate}}
              </td>
            </ng-container>
            <ng-container matColumnDef="comments">
              <th mat-header-cell mat-sort-header *matHeaderCellDef style="min-width: 5%">
                {{'Contribute.thComments' | translate}}
              </th>
              <td mat-cell *matCellDef="let element" matTooltip="{{checkTradeColumn(element, 'comments', true)}}" class="{{checkTradeColumn(element, 'comments') == 'true' ? 'hasChangedClass' : ''}}">
                {{element.comments}}
              </td>
            </ng-container>
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef class="stickyRightHeader">{{ 'thActions' | translate }}</th>
              <td mat-cell *matCellDef="let element" class="stickyRightColumn">
                <button mat-icon-button color="primary" (click)="OnEditTrade(element)" [disabled]="element.status == 'Cancelled' || element.state == 'watch_later'">
                  <mat-icon>edit</mat-icon>
                </button>
                &nbsp;
                <button mat-icon-button color="warn" (click)="OnDeleteTrade(element)" [disabled]="element.status == 'Cancelled' || element.state == 'watch_later'">
                  <mat-icon>delete_outline</mat-icon>
                </button>
              </td>
            </ng-container>
            <ng-container matColumnDef="loading">
              <th class="loading" mat-footer-cell *matFooterCellDef colspan="12">
                {{ 'tblLoading' | translate }}...
              </th>
            </ng-container>
            <ng-container matColumnDef="noData">
              <th class="loading" mat-footer-cell *matFooterCellDef colspan="12">
                {{ 'Contribute.tblNoData' | translate }}...
              </th>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayColumnsTrans; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayColumnsTrans;" matTooltip="{{row.notes}}"></tr>
            <tr mat-footer-row *matFooterRowDef="['loading']" [ngClass]="{'hide':dataSourceTrans!=null}"></tr>
            <tr mat-footer-row *matFooterRowDef="['noData']" [ngClass]="{'hide':(dataSourceTrans!=null && transRecordsLength != 0) || isLoading === true}"></tr>
          </table>
          <mat-paginator #pgTrans [pageSize]="5" [pageSizeOptions]="[5, 10, 25, 50]" [length]="transRecordsLength"></mat-paginator>
        </div>
      </div>
      @if (service.currentUser.isReadOnly === false) {
        <div class="mt-2">
          <button mat-raised-button style="float: right; margin-left: 10px;" color="primary" type="button" (click)="OnTransSaveClick()">{{'btnSave' | translate}}</button>
        </div>
      }
    </mat-tab>
  </mat-tab-group>
  @if (contributeMarket.isMarketOpen === false && contributeMarket.isAllowedUser === true && allowTransactions == false) {
    <div [@slider]="contributeMarket.isMarketOpen === false && contributeMarket.isAllowedUser === true ? 'show' : null" class="slider">
      <p>
        {{'Contribute.notReady' | translate}}
      </p>
    </div>
  }
  @if (contributeMarket.isAllowedUser === false  && isLoading === false) {
    <div [@slider]="contributeMarket.isAllowedUser === false  && isLoading === false ? 'show' : null" class="slider">
      <p>
        {{'Contribute.notAllowed' | translate}}
      </p>
    </div>
  }
  @if (contributeMarket.isMarketOpen === true && contributeMarket.isAllowedUser === true && (hasCurrentContributions === false && service.currentUser.isReadOnly === true)) {
    <div [@slider]="contributeMarket.isMarketOpen === true && contributeMarket.isAllowedUser === true && (hasCurrentContributions === false && service.currentUser.isReadOnly === true) ? 'show' : null" class="slider">
      <p>
        {{'Contribute.noContributions' | translate}}
      </p>
    </div>
  }
  @if (isLoading === true) {
    <div [@slider]="isLoading === true ? 'show' : null" class="slider">
      <p>
        {{'tblLoading' | translate}}...
      </p>
    </div>
  }
</div>
